import {
    CORS_MODE_NAME,
    fetchService,
    POST_METHOD_NAME,
    FetchRequestOptions,
    getEncodedUrlForVroom,
} from 'owa-data-provider-info-fetcher';
import { getSharesAPIBase } from 'owa-fileprovider-services';
import { RecipientPermissionResult } from 'owa-link-data';
import { format } from 'owa-localize';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { RecipientPermissionInfo } from 'owa-sharing-data';
import { parse as parseUrl } from 'url';

export async function checkRecipientPermissionService(
    location: string,
    recipients: RecipientPermissionInfo[]
): Promise<RecipientPermissionResult[]> {
    const requestUrl: string = getRequestUrl(location);
    const bodyContent: string = getBody(recipients);
    const requestOptions: FetchRequestOptions = {
        method: POST_METHOD_NAME,
        mode: CORS_MODE_NAME,
        body: bodyContent,
        datapointNamePrefix: 'checkRecipientPermission',
    };

    const responseText = await fetchService(
        AttachmentDataProviderType.OneDrivePro,
        requestUrl,
        location,
        requestOptions,
        null // additional headers
    );
    return JSON.parse(responseText).value;
}

function createRequestBody(recipientPermissionInfos: RecipientPermissionInfo[]) {
    return {
        recipients: recipientPermissionInfos.map(function(info) {
            return { alias: info.emailAddress };
        }),
    };
}
function getRequestUrl(location: string): string {
    const requestFormat = 'https://{0}/{1}/{2}/permission/checkAccess';
    return format(
        requestFormat,
        parseUrl(location).hostname,
        getSharesAPIBase(AttachmentDataProviderType.OneDrivePro),
        getEncodedUrlForVroom(location)
    );
}

function getBody(recipients: RecipientPermissionInfo[]): string {
    return JSON.stringify(createRequestBody(recipients));
}
